const theme = {
  fonts: {
    main: "Montserrat, sans-serif"
  },
  colors: {
    main1: "hsl(0, 0%, 25%)",
    main2: "hsl(0, 0%, 35%)",
    dark1: "hsl(0, 0%, 45%)",
    dark2: "hsl(0, 0%, 35%)",
    dark3: "hsl(0, 0%, 25%)",
    light1: "hsl(0, 0%, 90%)",
    light2: "hsl(0, 0%, 95%)",
    blue1: "hsl(204, 100%, 60%)",
    white: "hsl(0, 0%, 100%)"
  },
  breakpoints: {
    mobile: "only screen and (max-width: 50rem)",
    tablet: "only screen and (max-width: 65rem)"
  },
  spacings: {
    xxSmall: ".25rem",
    xSmall: ".5rem",
    small: "1rem",
    medium: "2rem",
    large: "3rem",
    xLarge: "4rem",
    xxLarge: "6rem"
  },
  animations: {
    button: "box-shadow 0.3s ease",
    link: "color 0.2s ease",
    navLink: "border 0.2s ease-in-out",
    sidebar: "all 0.3s linear",
    general: "all 0.3s linear"
  },
  shadows: {
    shadow1: "0px 5px 20px rgba(30, 30, 31, 0.05)",
    shadow2: "0px 5px 20px rgba(30, 30, 31, 0.2)"
  },
  sidebar: {
    background: "#000"
  }
}

export default theme
